import { profilesPicNames } from '../constants/profilesPicNames';
interface Profile {
  name: string;
  src: string;
  designation: string;
}

const isNameInArray = (profileName: string, namesArray: string[]): boolean => {
  return namesArray.includes(profileName);
};

export const filterProfilesByName = (namesArray: string[]): Profile[] => {
  if (namesArray && namesArray.length > 0) {
    return profilesPicNames.filter((profile) => isNameInArray(profile.name, namesArray));
  } else {
    return [{ name: '', src: '', designation: '' }];
  }
};

export const getNamesOnly = (filteredProfiles: Profile[]) => {
  const namesOnly = filteredProfiles.map((profile) => profile.name);
  return namesOnly.join(', ');
};
